<template>
  <b-modal v-model="model" centered modal-class="modal-bb-squared" hide-footer>
    <template slot="modal-header" slot-scope="{ close }">
      <h5>Apply for this position</h5>

      <p class="w-75 fs15 text-gray-700 pt-10">
        Applications for this job are handled outside of The Hub. Therefore, processing of your
        application will be handled outside of the Hub after continuing.
      </p>
      <button class="close" @click="close()"></button>
    </template>

    <template slot="default">
      <form>
        <FormItem
          v-if="!isUserLoggedIn()"
          class="mb-10"
          invalid-message="Please enter name"
          :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
          required
        >
          <b-form-input
            v-model="form.name"
            maxlength="100"
            :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
            placeholder="Your name"
          />
        </FormItem>

        <FormItem
          v-if="!isUserLoggedIn()"
          class="mb-10"
          invalid-message="Please enter email"
          :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
          required
        >
          <b-form-input
            v-model="form.email"
            :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
            placeholder="Email"
          />
        </FormItem>

        <FormItem :class="{ 'mt-20': !isUserLoggedIn() }">
          <b-form-checkbox v-model="form.updates">
            <div class="fs14 mt-1 text-gray-700">
              Send me email updates with similar positions
            </div>
          </b-form-checkbox>
        </FormItem>

        <AlertSlideUpDown :show="!!errorMessage">
          {{ errorMessage }}
        </AlertSlideUpDown>

        <div style="cursor:pointer" class="btn btn-lg w-100 mb-20" @click="onSubmit(job.link)">
          <span v-if="!isRequesting">Apply</span>
          <b-spinner v-else small />
        </div>

        <div class="fs14 mt-10">
          By sending the request you confirm that you accept our
          <router-link to="/terms" target="_blank" class="text-blue-900"
            >Terms of Service</router-link
          >
          and
          <router-link to="/privacy-policy" target="_blank" class="text-blue-900"
            >Privacy Policy</router-link
          >.
        </div>
      </form>
    </template>
  </b-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import FormItem from '@/components/form/FormItem';
import AlertSlideUpDown from '@/components/AlertSlideUpDown';

const initial = {
  name: undefined,
  email: undefined,
  updates: true
};

export default {
  components: {
    AlertSlideUpDown,
    FormItem
  },
  mixins: [validationMixin],
  props: {
    job: {
      required: true,
      type: Object
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data: () => ({
    isRequesting: false,
    errorMessage: '',
    form: initial
  }),
  computed: {
    user() {
      return this.$store.getters['user/data'];
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    questions() {
      if (!this.job.criterias.includes('text')) {
        return [];
      }

      return this.job.questions
        .filter((item) => item.isEnabled)
        .sort((itemA, itemB) => itemA.position - itemB.position);
    }
  },
  watch: {
    questions: {
      immediate: true,
      handler(value) {
        this.form.answers = value.map((item) => ({
          question: item.id,
          answer: ''
        }));
      }
    }
  },
  validations() {
    return {
      form: {
        email: {
          required,
          email
        },
        name: {
          required
        }
      }
    };
  },
  mounted() {
    if (this.user) {
      this.fillUserData();
    }
  },
  methods: {
    isUserLoggedIn() {
      return !!this.user;
    },
    fillUserData() {
      this.form.email = this.user.email;
      this.form.name = this.user.fullName;
    },
    // async onSubmit(url) {
    onSubmit(url) {
      if (this.isRequesting) {
        return;
      }

      this.$v.form.$touch(); // will trigger errors to appear.

      if (this.$v.form.$error) {
        console.log('Error?');
        return;
      } else {
        this.isRequesting = true;
        this.errorMessage = undefined;

        const formData = new FormData();

        for (const name in this.form) {
          if (this.form[name]) {
            formData.append(
              name,
              Array.isArray(this.form[name]) ? JSON.stringify(this.form[name]) : this.form[name]
            );
          }
        }
        window.open(url, '_blank');
        this.$axios
          .post(`/jobs/${this.job.id}/apply-scraped`, formData)
          .then((response) => {
            console.log(response);
            this.$emit('submitted', this.form);
            this.isRequesting = false;
          })
          .catch((error) => {
            this.errorMessage = error.message;
            this.isRequesting = false;
          });
        // try {
        //   await this.$axios.post(`/jobs/${this.job.id}/apply-scraped`, formData)
        //   setTimeout(() => {
        //     window.open(url, '_blank');
        //   }, 0)
        //   window.open(url, '_blank')
        //   this.$emit('submitted', this.form)
        // } catch (err) {
        //   this.errorMessage = err.message
        // }
        // this.isRequesting = false
      }
    }
  }
};
</script>
